// Reddit Ads Pixel — PageVisit-only client integration. SignUp attribution
// runs server-side via the Reddit Conversions API (api/lib/reddit-capi.ts):
// click_id is captured into pk_attribution on the marketing site, stamped to
// the users row via /api/me/attribution, and a SignUp event is fired from the
// API handler when a fresh-signup write lands. CAPI sidesteps ITP /
// ad-blockers / consent denials, so the client pixel doesn't need to handle
// the conversion event at all.
//
// Boot is invoked from the consent component after the user accepts the
// analytics category (mirrors bootClarity). Pre-boot calls would not be
// safe here: Reddit's snippet expects `init` to run before any `track`.

const REDDIT_PIXEL_ID = "a2_i7d47pj1gc2t";

type RedditPixel = {
  (action: string, ...args: unknown[]): void;
  callQueue?: unknown[][];
  sendEvent?: (...args: unknown[]) => void;
};

declare global {
  interface Window {
    rdt?: RedditPixel;
  }
}

export function bootRedditPixel(email?: string): void {
  if (typeof window === "undefined" || window.rdt) return;

  const p: RedditPixel = function (...args: unknown[]) {
    if (p.sendEvent) {
      p.sendEvent(...args);
    } else {
      (p.callQueue ??= []).push(args);
    }
  };
  p.callQueue = [];
  window.rdt = p;

  if (email) {
    window.rdt("init", REDDIT_PIXEL_ID, { email });
  } else {
    window.rdt("init", REDDIT_PIXEL_ID);
  }
  window.rdt("track", "PageVisit");

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.redditstatic.com/ads/pixel.js?pixel_id=${REDDIT_PIXEL_ID}`;
  const first = document.getElementsByTagName("script")[0];
  first?.parentNode?.insertBefore(script, first);
}
